
module.exports = () ->
  restrict: 'A'
  template: require('./uploaded-document-preview.tpl.html' )
